import * as constants from './constants';

export const setUserDetailsIsEdit = (data) => {
  return {
    type: constants.TENANT_USER_DETAILS_IS_EDIT,
    data: data,
  };
};

export const setUserPermissionsIsEdit = (data) => {
  return {
    type: constants.SET_TENANT_USER_PERMISSIONS_IS_EDIT,
    data,
  };
};

export const createUser = (data) => {
  return {
    type: constants.CREATE_TENANT_USER,
    data: data,
  };
};

export const createUserSuccess = (data) => {
  return {
    type: constants.CREATE_TENANT_USER_SUCCESS,
    data: data,
  };
};

export const createUserError = () => {
  return {
    type: constants.CREATE_TENANT_USER_ERROR,
  };
};

export const updateUserPermissions = (data) => {
  return {
    type: constants.UPDATE_TENANT_USER_PERMISSIONS,
    data: data,
  };
};

export const updateUserPermissionsSuccess = (data) => {
  return {
    type: constants.UPDATE_TENANT_USER_PERMISSIONS_SUCCESS,
    data: data,
  };
};

export const updateUserPermissionsError = () => {
  return {
    type: constants.UPDATE_TENANT_USER_PERMISSIONS_ERROR,
  };
};

export const fetchUser = (data) => {
  return {
    type: constants.FETCH_TENANT_USER,
    data: data,
  };
};

export const fetchUserSuccess = (data) => {
  return {
    type: constants.FETCH_TENANT_USER_SUCCESS,
    data,
  };
};

export const fetchUserError = () => {
  return {
    type: constants.FETCH_TENANT_USER_ERROR,
  };
};

export const updateUser = (data) => {
  return {
    type: constants.UPDATE_TENANT_USER,
    data: data,
  };
};

export const updateUserSuccess = (data) => {
  return {
    type: constants.UPDATE_TENANT_USER_SUCCESS,
    data: data,
  };
};

export const updateUserError = () => {
  return {
    type: constants.UPDATE_TENANT_USER_ERROR,
  };
};

export const updateUserSettings = (data) => {
  return {
    type: constants.UPDATE_TENANT_USER_SETTINGS,
    data: data,
  };
};

export const updateUserSettingsSuccess = (data) => {
  return {
    type: constants.UPDATE_TENANT_USER_SETTINGS_SUCCESS,
    data: data,
  };
};

export const updateUserSettingsError = () => {
  return {
    type: constants.UPDATE_TENANT_USER_SETTINGS_ERROR,
  };
};

export const fetchUserDetailsUtils = () => {
  return {
    type: constants.FETCH_TENANT_USERS_UTIL_DATA,
  };
};

export const fetchUserDetailsUtilsSuccess = (data) => {
  return {
    type: constants.FETCH_TENANT_USERS_UTIL_DATA_SUCCESS,
    data,
  };
};

export const fetchAllUsers = (data) => {
  return {
    type: constants.FETCH_ALL_TENANT_USERS,
    data,
  };
};

export const fetchAllUsersSuccess = (data) => {
  return {
    type: constants.FETCH_ALL_TENANT_USERS_SUCCESS,
    data,
  };
};

export const fetchAllUsersError = () => {
  return {
    type: constants.FETCH_ALL_TENANT_USERS_ERROR,
  };
};

export const deleteUser = (data) => {
  return {
    type: constants.DELETE_TENANT_USER,
    data,
  };
};

export const deleteUserSuccess = (data) => {
  return {
    type: constants.DELETE_TENANT_USER_SUCCESS,
    data,
  };
};

export const deleteUserError = (data) => {
  return {
    type: constants.DELETE_TENANT_USER_ERROR,
    data,
  };
};

export const userDetailCleanupFunc = () => {
  return {
    type: constants.TENANT_USER_DETAIL_CLEANUP_FUNC,
  };
};

export const sendDetailsToUser = (data) => {
  return {
    type: constants.SEND_DETAILS_TO_TENANT_USER,
    data: data,
  };
};

export const sendDetailsToUserSuccess = (data) => {
  return {
    type: constants.SEND_DETAILS_TO_TENANT_USER_SUCCESS,
    data: data,
  };
};

export const sendDetailsToUserError = () => {
  return {
    type: constants.SEND_DETAILS_TO_TENANT_USER_ERROR,
  };
};

export const setStorage = (data) => {
  return {
    type: constants.SET_TENANT_USERS_MANAGER_STATE,
    data,
  };
};
